import React from "react";
import { useMemo } from "react";
import messages from "./messages.i18n";
import { ScanRequestStatus } from "@piiqtechnologies/ui-lib";
import { PeekTypography } from "@piiqtechnologies/ui-components";
import { formatUTCDate } from "../../utils";
import { useAuthContext } from "@stores/AuthContext";
import { USER_ROLES } from "@constants/Roles";
export function ScanCompletedConfig({ dateRange, isAdminTable, debouncedSearchKey, communities, }) {
    const { user } = useAuthContext();
    const scanCompletedParams = useMemo(() => {
        return Object.assign({ search: debouncedSearchKey || undefined, status: [ScanRequestStatus.COMPLETED], order: "desc", orderBy: "scannedAt", communityId: communities && communities }, dateRange);
    }, [communities, dateRange, debouncedSearchKey]);
    const scanCompletedColumns = useMemo(() => {
        return [
            {
                id: "scannedAt",
                label: messages.scannedOn,
                sortable: true,
                render: (row) => ((row === null || row === void 0 ? void 0 : row.scannedAt) && formatUTCDate(row === null || row === void 0 ? void 0 : row.scannedAt)) || "-",
            },
            ...((isAdminTable && [
                {
                    id: "scannedBy.name",
                    label: messages.scannedBy,
                    sortable: true,
                    accessor: "scannedBy.name",
                },
                {
                    id: "community.organization.name",
                    label: messages.organization,
                    sortable: true,
                    accessor: "community.organization.name",
                },
            ]) ||
                []),
            {
                id: "community.name",
                label: messages.community,
                sortable: true,
                accessor: "community.name",
            },
            ...(((!isAdminTable || (user === null || user === void 0 ? void 0 : user.roleId) === USER_ROLES.Owner) && [
                {
                    id: "community.organization.name",
                    label: messages.organization,
                    sortable: true,
                    accessor: "community.organization.name",
                },
            ]) ||
                []),
            {
                id: "space.unit",
                label: messages.space,
                sortable: isAdminTable,
                accessor: "space.unit",
            },
            ...((!isAdminTable && [
                {
                    id: "space.floorPlan.name",
                    label: messages.floorPlan,
                    sortable: true,
                    accessor: "space.floorPlan.name",
                    render: (row) => { var _a, _b; return (((_a = row.space.floorPlan) === null || _a === void 0 ? void 0 : _a.name) ? (_b = row.space.floorPlan) === null || _b === void 0 ? void 0 : _b.name : "-"); },
                },
            ]) ||
                []),
            {
                id: "space.building.address.street",
                label: messages.address,
                sortable: isAdminTable,
                render: (row) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (React.createElement(PeekTypography, null, [
                        (_b = (_a = row.space.building) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.street,
                        (_d = (_c = row.space.building) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.city,
                        (_f = (_e = row.space.building) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.state,
                        (_h = (_g = row.space.building) === null || _g === void 0 ? void 0 : _g.address) === null || _h === void 0 ? void 0 : _h.postalCode,
                    ]
                        .filter(Boolean)
                        .join(", ") || "-"));
                },
            },
            ...((!isAdminTable && [
                {
                    id: "requestedBy.name",
                    label: messages.requestedBy,
                    sortable: false,
                    accessor: "requestedBy.name",
                },
            ]) ||
                []),
        ];
    }, []);
    return {
        scanCompletedParams,
        scanCompletedColumns,
    };
}
